import { JobDetailResponse } from '@doda/api-client/aspida/@types';

/**
 * パンくずリスト構造化データ作成
 * @param job 求人情報
 * @param domain ドメイン
 * @param lastText 求人名の末尾テキスト
 * @returns JSON
 */
export const createBreadCrumbListLd = (
  job: JobDetailResponse,
  domain: string,
  lastText: string
) => {
  const list: {
    '@type': string;
    position: number;
    item: { '@id': string; name: string };
  }[] = [];
  list.push({
    '@type': 'ListItem',
    position: 1,
    item: {
      '@id': `${domain}/`,
      name: '転職・求人doda（デューダ）トップ',
    },
  });
  let position = 2;
  if (job.job?.analysis?.industryLName && job.industry?.industryLURL) {
    list.push({
      '@type': 'ListItem',
      position,
      item: {
        '@id': `${domain}${job.industry.industryLURL}`,
        name: job.job.analysis.industryLName,
      },
    });
    position += 1;
  }
  if (job.job?.analysis?.industrySName && job.industry?.industrySURL) {
    list.push({
      '@type': 'ListItem',
      position,
      item: {
        '@id': `${domain}${job.industry.industrySURL}`,
        name: job.job.analysis.industrySName,
      },
    });
    position += 1;
  }
  let jdUrl = '';
  if (job.job?.jid) {
    jdUrl = `${domain}/DodaFront/View/JobSearchDetail/j_jid__${job.job.jid}/`;
    // E原稿の場合、募集要項へのリンクのURLに付与されるパラメータを追加で付与
    if (job.job?.recuruitPrImage?.imageHTML) {
      jdUrl += '-tab__jd/';
    }
  }
  // 企業TOPページが存在する場合
  if (job.job?.companyId) {
    if (job.job?.corporateName) {
      list.push({
        '@type': 'ListItem',
        position,
        item: {
          '@id': `${domain}/DodaFront/View/CompanyJobs/j_id__${job.job.companyId}/`,
          name: `${job.job.corporateName}${lastText}`,
        },
      });
      position += 1;
    }
    if (job.job?.occupationName && jdUrl !== '') {
      list.push({
        '@type': 'ListItem',
        position,
        item: {
          '@id': jdUrl,
          name: `${job.job.occupationName}${lastText}`,
        },
      });
    }
  } else if (
    job.job?.corporateName &&
    job.job?.occupationName &&
    jdUrl !== ''
  ) {
    list.push({
      '@type': 'ListItem',
      position,
      item: {
        '@id': jdUrl,
        name: `${job.job.corporateName}／${job.job.occupationName}${lastText}`,
      },
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: list,
  };
};
